import React, { useState, useEffect, useContext } from 'react'
import emailListContext from '../../../context/context'
import { SaveAlt } from '@material-ui/icons'
import Modal from 'react-modal'
import DownloadEmailList from '../../../Dashboard/EmailListActions/DownloadEmailList/DownloadEmailList'
import { getPostMailingContatsCount } from '../../../Services'

export default function DownloadEmailListButton() {

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '0px !important'
        },
        overlay: { zIndex: 1050 }
    }

    const { emailList, setSnackBar } = useContext(emailListContext)
    const [modalIsOpen, setIsOpen] = useState(false)
    const [selectedOption, setSelectedOption] = useState('')
    const [count, setCount] = useState('')

    useEffect(() => {
        getCount()
    }, [emailList])

    const getCount = async () => {
        const response2 = await getPostMailingContatsCount({
            polarisEmailListId: emailList.polarisEmailListId,
            "postalMailingContacts": true,
            recordStatus: "Published"
        })
        setCount(response2.data.count)
    }

    const componentToLoad = {
        DownloadEmailList: <DownloadEmailList list={emailList} count={count} closeModal={closeModal} />
    }

    function openModal(inpuVal) {
        setSelectedOption(inpuVal)
        setIsOpen(true)
    }

    function closeModal() {
        setIsOpen(false)
    }

    return (
        <>
            <button disabled={!emailList.polarisEmailListId} data-testid="test-button-download-EL" onClick={() => { openModal('DownloadEmailList') }} role="button" className="btn btn-primary">
                <SaveAlt fontSize="small" className="pr-2" />
                Download
            </button>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} >
                {componentToLoad[selectedOption]}
            </Modal>
        </>
    );
}
